import { CalendarIcon, ClockIcon, GraphDownIcon, ManagerIcon, PiggyBankIcon, SellIcon } from '@cash-me/react-components'
export const benefits = [
  {
    id: '1',
    icon: GraphDownIcon,
    title: 'Taxas mais baixas',
    description: 'Opções pré e pós-fixadas.'
  },
  {
    id: '2',
    icon: CalendarIcon,
    title: 'Carência',
    description: 'Carência de até 3 meses.'
  },
  {
    id: '3',
    icon: ClockIcon,
    title: 'Prazos mais longos',
    description: 'Até 240 meses para pagar.'
  },
  {
    id: '4',
    icon: SellIcon,
    title: 'Análise de crédito',
    description: 'Agilidade na realização da análise de crédito.'
  },
  {
    id: '5',
    icon: PiggyBankIcon,
    title: 'Valores maiores',
    description: 'A partir de R$ 50 mil em empréstimo.'
  },
  {
    id: '6',
    icon: ManagerIcon,
    title: 'Assessoria personalizada',
    description: 'Auxílio de nossos consultores de acordo com a sua necessidade.'
  }
]
